<template>
  <div class="bread-crumb-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in data"
        v-bind:key="index"
        :to="{ path: item.path }"
      >
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadCrumb',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="less">
  @breadCrumbHeight: 50px;
  .bread-crumb-content {
    width: 100%;
    padding: 0 20px;
    height: @breadCrumbHeight;
    background: #fff;
    line-height: @breadCrumbHeight;
    box-sizing: border-box;
    border-bottom: 1px dashed #f2f2f2;
    .el-breadcrumb {
      line-height: @breadCrumbHeight;
    }
  }
</style>
